import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ab24015"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "youtube" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "player" }, null, -1))
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "mask" }

import { nextTick, onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import { useHome, useMedia } from '@/store';

export default /*#__PURE__*/_defineComponent({
  __name: 'Player',
  setup(__props) {

const { videoPauseImg, videoEndImg } = storeToRefs(useHome());
const { youtube, youtubeCover, player, playerState } = storeToRefs(useMedia());
const { updatePlayer, updatePlayerState, updateYoutubeCover } = useMedia();

const changeStateAndCover = (state: string, img: string) => {
  updatePlayerState(state);
  updateYoutubeCover(img);
};
const play = () => {
  player.value.playVideo();
};

function onPlayerReady(event) {
  event.target.stopVideo();
}
function onPlayerStateChange(event: { [key: string]: any }) {
  if (event.data === -1) {
    changeStateAndCover('unstarted', youtubeCover.value);
  } else if (event.data === 5) {
    changeStateAndCover('cued', youtubeCover.value);
  } else if (event.data === window.YT.PlayerState.PAUSED) {
    changeStateAndCover('paused', videoPauseImg.value);
  } else if (event.data === window.YT.PlayerState.ENDED) {
    changeStateAndCover('ended', videoEndImg.value);
  } else {
    changeStateAndCover('', '');
  }
}
function onYouTubeIframeAPIReady() {
  window.YT.ready(function () {
    updatePlayer(
      new window.YT.Player('player', {
        height: '100%',
        width: '100%',
        videoId: youtube.value,
        playerVars: {
          fs: 1,
          controls: 1,
          enablejsapi: 1,
          origin: window.location.origin,
          // eslint-disable-next-line @typescript-eslint/camelcase
          iv_load_policy: 3,
          modestbranding: 1,
          playsinline: 1,
          autoplay: 1,
          rel: 0,
        },
        events: {
          onReady: onPlayerReady,
          onStateChange: onPlayerStateChange,
        },
      }),
    );
  });
}
onMounted(async () => {
  await nextTick();
  if (window.YT) onYouTubeIframeAPIReady();
  window.onYouTubePlayerAPIReady = onYouTubeIframeAPIReady;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (
        _unref(playerState) === 'unstarted' ||
        _unref(playerState) === 'cued' ||
        _unref(playerState) === 'paused' ||
        _unref(playerState) === 'ended'
      )
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("img", {
            class: "cover",
            src: _unref(youtubeCover),
            alt: "",
            draggable: "false"
          }, null, 8, _hoisted_3),
          _withDirectives(_createElementVNode("div", _hoisted_4, null, 512), [
            [_vShow, _unref(playerState) === 'paused' || _unref(playerState) === 'ended']
          ]),
          _createElementVNode("button", {
            class: _normalizeClass(['play', _unref(playerState)]),
            type: "button",
            onClick: play
          }, null, 2)
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})